import { useQuery } from '@tanstack/react-query';
import { fetchNotificationsList, fetchUnreadNotificationCount } from '../../api/notifications';
import { queryKeys } from '../../lib/query/queryKeys';
import { GC, STALE } from '../../lib/query/staleTimes';

export function useUnreadNotificationCount(userId, { enabled = true } = {}) {
  return useQuery({
    queryKey: queryKeys.notifications.unreadCount(userId),
    queryFn: () => fetchUnreadNotificationCount(userId),
    enabled: Boolean(userId) && enabled,
    staleTime: STALE.realtime,
    gcTime: GC.default,
  });
}

export function useNotificationsList(userId, filter = 'all', { enabled = true } = {}) {
  return useQuery({
    queryKey: queryKeys.notifications.list(userId, filter),
    queryFn: () => fetchNotificationsList(userId, filter),
    enabled: Boolean(userId) && enabled,
    staleTime: STALE.realtime,
    gcTime: GC.default,
  });
}
